/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListReferentialVariable } from '../models/api-response-list-referential-variable';
import { ApiResponsePagedResultReferentialVariable } from '../models/api-response-paged-result-referential-variable';
import { ApiResponseReferentialVariable } from '../models/api-response-referential-variable';
import { createReferentialVariable } from '../fn/referential-variable-api/create-referential-variable';
import { CreateReferentialVariable$Params } from '../fn/referential-variable-api/create-referential-variable';
import { getReferentialVariableByRef } from '../fn/referential-variable-api/get-referential-variable-by-ref';
import { GetReferentialVariableByRef$Params } from '../fn/referential-variable-api/get-referential-variable-by-ref';
import { listReferentialVariable1 } from '../fn/referential-variable-api/list-referential-variable-1';
import { ListReferentialVariable1$Params } from '../fn/referential-variable-api/list-referential-variable-1';
import { patchArchiveStatus3 } from '../fn/referential-variable-api/patch-archive-status-3';
import { PatchArchiveStatus3$Params } from '../fn/referential-variable-api/patch-archive-status-3';
import { searchReferentialVariable } from '../fn/referential-variable-api/search-referential-variable';
import { SearchReferentialVariable$Params } from '../fn/referential-variable-api/search-referential-variable';
import { updateReferentialVariable } from '../fn/referential-variable-api/update-referential-variable';
import { UpdateReferentialVariable$Params } from '../fn/referential-variable-api/update-referential-variable';

@Injectable({ providedIn: 'root' })
export class ReferentialVariableApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getReferentialVariableByRef()` */
  static readonly GetReferentialVariableByRefPath = '/v1/api/admin-ui/referential/variable/{ref}';

  /**
   * Requires ADMIN_SOLUTION_UI and exact SOLUTION group membership. Dashy admins manage global definitions and inspect company definitions read-only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReferentialVariableByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReferentialVariableByRef$Response(params: GetReferentialVariableByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialVariable>> {
    return getReferentialVariableByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * Requires ADMIN_SOLUTION_UI and exact SOLUTION group membership. Dashy admins manage global definitions and inspect company definitions read-only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReferentialVariableByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReferentialVariableByRef(params: GetReferentialVariableByRef$Params, context?: HttpContext): Observable<ApiResponseReferentialVariable> {
    return this.getReferentialVariableByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialVariable>): ApiResponseReferentialVariable => r.body)
    );
  }

  /** Path part for operation `updateReferentialVariable()` */
  static readonly UpdateReferentialVariablePath = '/v1/api/admin-ui/referential/variable/{ref}';

  /**
   * Requires ADMIN_SOLUTION_UI and exact SOLUTION group membership. Dashy admins manage global definitions and inspect company definitions read-only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateReferentialVariable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReferentialVariable$Response(params: UpdateReferentialVariable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialVariable>> {
    return updateReferentialVariable(this.http, this.rootUrl, params, context);
  }

  /**
   * Requires ADMIN_SOLUTION_UI and exact SOLUTION group membership. Dashy admins manage global definitions and inspect company definitions read-only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateReferentialVariable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReferentialVariable(params: UpdateReferentialVariable$Params, context?: HttpContext): Observable<ApiResponseReferentialVariable> {
    return this.updateReferentialVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialVariable>): ApiResponseReferentialVariable => r.body)
    );
  }

  /** Path part for operation `createReferentialVariable()` */
  static readonly CreateReferentialVariablePath = '/v1/api/admin-ui/referential/variable';

  /**
   * Requires ADMIN_SOLUTION_UI and exact SOLUTION group membership. Dashy admins manage global definitions and inspect company definitions read-only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createReferentialVariable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReferentialVariable$Response(params: CreateReferentialVariable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialVariable>> {
    return createReferentialVariable(this.http, this.rootUrl, params, context);
  }

  /**
   * Requires ADMIN_SOLUTION_UI and exact SOLUTION group membership. Dashy admins manage global definitions and inspect company definitions read-only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createReferentialVariable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReferentialVariable(params: CreateReferentialVariable$Params, context?: HttpContext): Observable<ApiResponseReferentialVariable> {
    return this.createReferentialVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialVariable>): ApiResponseReferentialVariable => r.body)
    );
  }

  /** Path part for operation `searchReferentialVariable()` */
  static readonly SearchReferentialVariablePath = '/v1/api/admin-ui/referential/variable/search';

  /**
   * Requires ADMIN_SOLUTION_UI and exact SOLUTION group membership. Dashy admins manage global definitions and inspect company definitions read-only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchReferentialVariable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchReferentialVariable$Response(params: SearchReferentialVariable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultReferentialVariable>> {
    return searchReferentialVariable(this.http, this.rootUrl, params, context);
  }

  /**
   * Requires ADMIN_SOLUTION_UI and exact SOLUTION group membership. Dashy admins manage global definitions and inspect company definitions read-only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchReferentialVariable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchReferentialVariable(params: SearchReferentialVariable$Params, context?: HttpContext): Observable<ApiResponsePagedResultReferentialVariable> {
    return this.searchReferentialVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultReferentialVariable>): ApiResponsePagedResultReferentialVariable => r.body)
    );
  }

  /** Path part for operation `patchArchiveStatus3()` */
  static readonly PatchArchiveStatus3Path = '/v1/api/admin-ui/referential/variable/archive/{ref}';

  /**
   * Requires ADMIN_SOLUTION_UI and exact SOLUTION group membership. Dashy admins manage global definitions and inspect company definitions read-only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchArchiveStatus3()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatus3$Response(params: PatchArchiveStatus3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchArchiveStatus3(this.http, this.rootUrl, params, context);
  }

  /**
   * Requires ADMIN_SOLUTION_UI and exact SOLUTION group membership. Dashy admins manage global definitions and inspect company definitions read-only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchArchiveStatus3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatus3(params: PatchArchiveStatus3$Params, context?: HttpContext): Observable<void> {
    return this.patchArchiveStatus3$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listReferentialVariable1()` */
  static readonly ListReferentialVariable1Path = '/v1/api/admin-ui/referential/variable/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listReferentialVariable1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialVariable1$Response(params: ListReferentialVariable1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListReferentialVariable>> {
    return listReferentialVariable1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listReferentialVariable1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialVariable1(params: ListReferentialVariable1$Params, context?: HttpContext): Observable<ApiResponseListReferentialVariable> {
    return this.listReferentialVariable1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListReferentialVariable>): ApiResponseListReferentialVariable => r.body)
    );
  }

}
